import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios';
import { setNetworkStatus } from '../../app/state/slices/global-slice';
import { store } from '../../app/state/store';
import { envConfig } from '../../configs/env';
import { getAuthInstance } from '../auth/auth-instance';
import { IRequestOptions } from './axios-api-v2-generated';

export function createInstance() {
    const instance = axios.create({ withCredentials: true });
    let networkError = false;

    instance.interceptors.request.use(async (config: InternalAxiosRequestConfig<any> & IRequestOptions) => {
        config.baseURL = envConfig.service;
        if (config.withAuthorization) {
            const token = await getAuthInstance().acquireToken();
            if (token) {
                config.headers['Authorization'] = `Bearer ${token}`;
            } else {
                throw new axios.Cancel('no token');
            }
        }
        config.paramsSerializer = { indexes: null };
        return config;
    });

    instance.interceptors.response.use(
        (response) => {
            if (networkError) {
                networkError = false;
                store.dispatch(setNetworkStatus({ offline: false }));
            }
            return response;
        },
        (error: AxiosError) => {
            // If there's no response then it's likely a network error
            if (!error.response) {
                if (!networkError) {
                    store.dispatch(setNetworkStatus({ offline: true }));
                }
                networkError = true;
            }

            // Ignore 401s for now. We could've been late with refreshing the token (unlikely, there's 15s buffer we put in on the client side)
            // The only case where the user is logged out is when refresh-token endpoint returns (successfully) 400.

            throw error;
        }
    );
    return instance;
}
